<template>
  <section class="guard-dashboard">
    <div class="container">
      <div class="white-common-box pa-3 mt-5 mb-3">
        <div class="d-flex align-center">
          <div class="control">
            <input
              type="text"
              class="input"
              placeholder="Search"
              v-model="searchText"
              @keyup.enter="onFilter"
            />
          </div>
          <!-- <button class="button is-info ml10" @click="onFilter">Search</button> -->
          <div class="select ml10">
            <select v-model="perPage" @change="onPerPageChange">
              <option value="5">5 per page</option>
              <option value="10">10 per page</option>
              <option value="25">25 per page</option>
              <option value="50">50 per page</option>
              <option value="100">100 per page</option>
            </select>
          </div>
          <div class="flex-grow-1 d-flex justify-end">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="profileAnchorColor"
                  class="whiteColor--text text-none font-weight-bold"
                  :disabled="loading"
                  v-bind="attrs"
                  v-on="on"
                >
                  Download as CSV
                  <v-icon right>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="opt in downloadMonths"
                  :key="opt.value || 'all'"
                  @click="downloadAllAsCSV(opt.value)"
                >
                  <v-list-item-title>{{ opt.label }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
      
      <div class="white-common-box pa-3">
        <b-table
          :data="records"
          :loading="isLoading"
          paginated
          backend-pagination
          :total="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          @page-change="onPageChange"
          backend-sorting
          :default-sort-direction="defaultSortOrder"
          :default-sort="[sortField, sortOrder]"
          @sort="onSort"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="AI article ID" sortable class="text-center">
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="runId" label="Report ID" sortable class="text-center">
              {{ props.row.runId }}
            </b-table-column>
            <b-table-column field="createdAt" label="Date created" sortable>
              {{ toLocalDateString(props.row.createdAt) }}
            </b-table-column>
            <b-table-column field="editedAt" label="Last edited date" sortable>
              {{ toLocalDateString(props.row.editedAt) }}
            </b-table-column>
            <b-table-column field="keyword" label="Keyword" sortable>
              {{  props.row.keyword }}
            </b-table-column>
            <b-table-column field="url" label="URL" sortable>
              {{ props.row.url }}
            </b-table-column>
            <b-table-column field="totalCredits" label="Credits used" sortable class="text-center">
              {{ props.row.totalCredits }}
            </b-table-column>
            <b-table-column field="creatorEmail" label="Created by" sortable>
              {{ props.row.creatorEmail }}
            </b-table-column>
            <b-table-column field="estimatedCost" label="Est. cost" class="text-center">
              {{ fmtCost(props.row.estimatedCost) }}
            </b-table-column>
            <b-table-column field="goto-report" label="Action" class="text-center">
              <a class="view-link" @click="() => viewAIReport(props.row)">
                View
              </a>
            </b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
            <div>Information {{ props.row.page.id }}</div>
          </template>
        </b-table>
      </div>
    </div>

  </section>
</template>

<script>

import { toLocalDateString } from "@/utils";
import { downloadServedFile, downloadInvoicePdf } from '@/utils/served-files'
import { mixin as exportmixin } from "@/components/export_mixin";

export default {
  name: "AIWriterLogDashboardForAdmin",
  mixins: [exportmixin],
  components: {
  },
  computed: {
    // CSV download options: "All" + the last 12 months (value 'YYYY-MM' for the
    // backend month filter, label 'YYYY - MM').
    downloadMonths() {
      const opts = [{ label: "All", value: "" }];
      const now = new Date();
      for (let i = 0; i < 12; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        opts.push({ label: `${y} - ${m}`, value: `${y}-${m}` });
      }
      return opts;
    },
    isAgencyUnlimitedUser() {
      return this.$store.getters.isAgencyUnlimitedUser;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    user() {
      return this.$store.state.user;
    },
    selectedSubAccountRelation () {
      return this.$store.state.selectedSubAccountRelation
    },
  },
  data() {
    return {

      isLoading: false,
      totalRows: 0,
      records: [],
      currentPage: 1,
      perPage: 10,
      sortField: "id",
      sortOrder: "desc",
      defaultSortOrder: "asc",
      searchText: "",
    };
  },
  methods: {
    viewAIReport(aiRun) {
      let queryParams = {}      
      queryParams = {
        pageRunId: aiRun.pageRunId,
        aiRunId: aiRun.id,
      }
      queryParams['editorMode'] = 'AI_MODE'
      
      if (this.selectedSubAccountRelation) {
        queryParams['relId'] = this.selectedSubAccountRelation.id
      }
      let routeData = this.$router.resolve({name: 'FullPageSourceEditor', query: queryParams});
      window.open(routeData.href, '_blank')
    },
    toLocalDateString(dateStr) {
      return toLocalDateString(dateStr);
    },
    onPerPageChange() {
      this.$nextTick(() => this.loadData());
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.loadData();
    },
    fmtCost(v) {
      return "$" + Number(v || 0).toFixed(4);
    },
    onFilter() {
      // console.log('filtering')
      this.$nextTick(() => {
        this.loadData();
      });
    },
    loadData() {
      // remove full screen loading indicator for speed up (to feel user experience)
      // this.$store.commit('showLoading')
      this.isLoading = true;
      const params = [
        `sortField=${this.sortField}`,
        `sortOrder=${this.sortOrder}`,
        `page=${this.currentPage}`,
        `perPage=${this.perPage}`,
        `filterText=${this.searchText}`
      ].join("&");

      this.$store
        .dispatch("getAIRunsForAdmin", { params })
        .then(({ data }) => {
          const { total, records } = data;
          this.totalRows = total;
          this.records = records;

        })
        .finally(() => {
          // this.$store.commit('hideLoading')
          this.isLoading = false;
        });
    },
    goBack () {
      this.$router.go(-1);
    },
    downloadAllAsCSV(month) {
      if (confirm("This action will download AI Run records and may take some time. Do not close this window until file is ready.")) {
        this.$store.commit('showLoading')

        const params = [
          `get_all_as_csv=1`,
          `month=${month || ""}`,
        ].join("&");
  
        this.$store
          .dispatch("getAIRunsForAdmin", { params })
          .then((response) => {
  
            if (response?.data?.status === 'SUCCESS' && response?.data?.taskId) {

              const taskId = response.data.taskId

              let interval = setInterval(() => {
                this.$store.dispatch('getTaskStatus', taskId)
                .then(response => {
                  if (response.data && response.data.status) {
                    if (response.data.status == 'SUCCESS') {
                      clearInterval(interval)
                      this.$store.commit('hideLoading')

                      downloadServedFile(response.data.url)
                    } else if (response.data.status == 'FAILURE') {
                      clearInterval(interval)
                      this.$store.commit('hideLoading')
                      this.$notify({
                        group: 'info', type: 'error',
                        text: 'Failed to download.'
                      })
                    }
                  }
                })
              }, 5000)
            } else {
              this.$store.commit('hideLoading')
            }

          })
          .catch(() => {
            this.$store.commit('hideLoading')
          });
      }
    }
  },
  mounted() {
    if (this.records.length == 0) {
      this.loadData();
    }
  }
};
</script>

<style scoped lang="scss">
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--v-mainColor-base);
}

.tabs {
  border: 2px solid var(--v-gray12Color-base);
  border-radius: 7px;
  margin-top: 40px;
  margin-bottom: 40px;
  & > div {
    cursor: pointer;
    padding: 15px 20px;
  }
  & > div:first-child {
    border-right: 2px solid var(--v-gray12Color-base);
  }
  & > div.active {
    background: var(--v-gray13Color-base);
  }

}

.summary-date-box {
  background: var(--v-green6Color-base);
  color: var(--v-green7Color-base);
  border-radius: 5px;
  padding: 3px 5px 3px 5px;
}

.task-pending {
  padding: 5px 10px;
  border-radius: 10px;
  color: var(--v-red2Color-base);
  background: var(--v-red1Color-base);
  font-weight: bold;
}
.all-good {
  padding: 5px 10px;
  border-radius: 10px;
  color: var(--v-green5Color-base);
  background: var(--v-green4Color-base);
  font-weight: bold;
}

.view-link {
  color: var(--v-link1Color-base);
  font-weight: bold;
}

.b-table {
  td {
    vertical-align: middle;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

</style>
